import { UnsavedPhotoModelsError } from 'settings/errors';
import reportError from 'utils/report-error';

/**
 * Reports a failed autosave unless the failure is already owned by the UI.
 *
 * Import and select suppress the global upload error dialog while they are
 * open, and overview while it waits on file conversion and shows its own
 * upload errors dialog, so a save that meets failed photo uploads in that
 * window rejects with UnsavedPhotoModelsError. That rejection is expected:
 * when the suppression ends (on unmount, or once overview finds no failed
 * uploads) the flow calls AppStateModule.restoreUploadErrorDialog, which
 * re-enables the dialog and, while autosave is on and the product is still
 * unsaved, saves again so any remaining failures are presented to the user.
 *
 * @param error Rejection from the autosave attempt.
 */
export default function reportAutoSaveFailure(error: unknown): void {
	if (error instanceof UnsavedPhotoModelsError) {
		return;
	}

	reportError(
		error,
		'warning',
	);
}
